export enum ScreenSize {
	xSmall = '575.98px',
	small = '767.98px',
	medium = '991.98px',
	large = '1200px',
}

export enum ScreenSizeWidth {
	small = 767.98,
}

export enum FontFamily {
	charlieBold = 'Charlie-Std-SemiBold, HelveticaNeueLTStd-Roman, Helvetica, Arial, sans-serif',
	charlieRegular = 'Charlie-Std-Regular, HelveticaNeueLTStd-Roman, Helvetica, Arial, sans-serif',
}

export enum Color {
	border = '#dcdad6',
}
